module.exports = __webpack_public_path__ + "static/course.7ba5a391.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/course.jpg
// module id = 304
// module chunks = 40275710597918 191283472321578